module.exports = __webpack_public_path__ + "static/media/vugr.ed7dbd05.png";